module.exports = __webpack_public_path__ + "static/profile-109624357b5c8b39085805bbeb24e9bc.png";